import Vue from 'vue'
import VueRouter from "vue-router";
import PageDate from "@/pages/PageDate";
import PageLanguages from "@/pages/PageLanguages";

const router = new VueRouter({
    routes: [
        {
            name:"home",
            path: '/',
            component: PageLanguages
        },
        {
            name:"date",
            path: '/:langue/date/:id',
            component: PageDate
        },

    ]
});
Vue.use(VueRouter);
export default router;